/**
 * FILE-OVERVIEW:
 * - 役割: メモ画面モバイル用下部ナビゲーション。
 * - 主な連携: MemoCalendarMain.js
 * - 本番運用上の注意: 固定バー変更時は画面下部被りをテストする。
 */

import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ListIcon from '@mui/icons-material/List';

const MemoNavigation = ({ calendarRef, onViewChange }) => {
  const handleViewChange = (viewType) => {
    if (calendarRef.current) {
      calendarRef.current.getApi().changeView(viewType);
    }
  };

  const navItems = [
    {
      key: 'prev',
      label: '前へ',
      icon: <ArrowBackIcon fontSize="small" />,
      onClick: () => calendarRef.current?.getApi().prev(),
      isActive: false,
    },
    {
      key: 'day',
      label: '日',
      icon: <CalendarTodayIcon fontSize="small" />,
      onClick: () => handleViewChange('dayGridDay'),
      isActive: false,
    },
    {
      key: 'list',
      label: 'リスト',
      icon: <ListIcon fontSize="small" />,
      onClick: () => handleViewChange('listWeek'),
      isActive: false,
    },
    {
      key: 'today',
      label: '今日',
      icon: <EventAvailableIcon fontSize="small" />,
      onClick: () => calendarRef.current?.getApi().today(),
      isActive: false,
    },
    {
      key: 'next',
      label: '次へ',
      icon: <ArrowForwardIcon fontSize="small" />,
      onClick: () => calendarRef.current?.getApi().next(),
      isActive: false,
    },
  ];

  const getActionButtonSx = (isActive) => ({
    width: 36,
    height: 36,
    color: isActive ? '#1a73e8' : '#5f6368',
    bgcolor: isActive ? '#e8f0fe' : 'transparent',
    borderRadius: 2,
    transition: 'all 0.2s ease',
    '&:hover': {
      bgcolor: isActive ? '#dce8fd' : '#f1f3f4',
    },
    '&:active': {
      transform: 'scale(0.96)',
    },
  });

  return (
    <Box
      className="memo-bottom-nav"
      sx={{
        position: 'fixed',
        bottom: 'var(--mobile-footer-nav-bottom)',
        left: 12,
        right: 12,
        height: 'var(--mobile-footer-nav-height)',
        zIndex: 20,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: 'rgba(255,255,255,0.96)',
        border: '1px solid #e5e9f0',
        boxShadow: '0 6px 18px rgba(60,64,67,0.22), 0 2px 8px rgba(60,64,67,0.14)',
        borderRadius: 4,
        px: 0.75,
        py: 0.375,
        boxSizing: 'border-box',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
      }}
    >
      {navItems.map((item) => (
        <Box
          key={item.key}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            flex: 1,
            minWidth: 0,
          }}
        >
          <IconButton
            onClick={item.onClick}
            sx={getActionButtonSx(item.isActive)}
            aria-label={item.label}
          >
            {item.icon}
          </IconButton>
          <Typography
            sx={{
              fontSize: '10px',
              fontWeight: item.isActive ? 600 : 500,
              color: item.isActive ? '#1a73e8' : '#5f6368',
              mt: 0.25,
              lineHeight: 1.2,
            }}
          >
            {item.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default MemoNavigation;
